import React, { useEffect, useState, useContext, useRef, useImperativeHandle } from "react";
import { Link, useLocation } from "react-router-dom";

import api from "services/api";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";

import Tooltip from "@mui/material/Tooltip";

import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import SuiBadgeDot from "components/SuiBadgeDot";
import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";

import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";

import toast from "react-hot-toast";

import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import { moodboardSortOptions } from "utils/data";
import { compare } from "utils/helper";
import defaultStyleImage from "assets/images/upstyled/default_background.png";
import Prompt from "components/UpStyled/Prompt";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import { Empty } from "antd";

const ImportMoodboardPicture = ({
  visible,
  handleClose,
  handleOk,
  isMulti = true,
  handleRefresh = () => {},
}) => {
  const [moodboards, setMoodboards] = useState([]);
  const [filteredMoodboards, setFilteredMoodboards] = useState([]);

  const [selectedItems, setSelectedItems] = useState([]);
  const [orderOpt, setOrderOpt] = useState(moodboardSortOptions[0]);
  const [searchStr, setSearchStr] = useState("");
  const [duplicateVisible, setDuplicateVisible] = useState(false);
  const [dupName, setDupName] = useState("");

  useEffect(() => {
    if (visible) {
      retrieveMoodboards();
      console.log("render");
    }
  }, [visible]);

  const retrieveMoodboards = async () => {
    try {
      const { data } = await api.moodboard.list();

      let myMoodboard = data?.moodboards || [];
      myMoodboard = myMoodboard
        .filter((x) => x?.img?.url)
        .sort((a, b) => compare(a, b, "-updated_at"));

      setMoodboards(myMoodboard);
      setFilteredMoodboards(myMoodboard);
      console.log(myMoodboard);
    } catch (err) {
      toast.error(`Retrieve moodboards failed!`);
      console.log(err);
    }
  };

  const renderPhoto = (props) => {
    const photo = props;
    const findIndex = selectedItems.findIndex((x) => x.id == photo.id);
    return (
      <div style={{ padding: "4px" }}>
        <Card
          className="moodboard-wrapper"
          onClick={() => {
            let items = [...selectedItems];
            if (findIndex != -1) {
              //remove the selected one
              const newItems = items.filter((x) => x.id != photo.id);
              setSelectedItems(newItems);
            } else {
              //add the selected one
              if (isMulti) {
                items.push(photo);
                setSelectedItems(items);
              } else {
                //only keep one selected moodboard
                setSelectedItems([photo]);
              }
            }
          }}
          style={{
            position: "relative",
            cursor: "pointer",
            borderRadius: "18px",
            overflow: "hidden",
            maxHeight: 400,
            width: "100%",
            border: findIndex != -1 ? "3px solid rgb(34 211 238)" : "none",
          }}
        >
          <ImageCardWrapper
            data={photo?.img}
            isOriginalSize={true}
            borderRadius="16px"
            pdfPagination={false}
            sx={{ height: "auto", width: "100%" }}
          />

          {/* <img
            style={{ borderRadius: "16px", height: "auto", width: "100%" }}
            alt={photo?.img?.name}
            src={photo?.img?.url || defaultStyleImage}
          /> */}
          <SuiBox className="img-controls">
            <SuiTypography
              variant="body1"
              color="white"
              textTransform="none"
              sx={{ whiteSpace: "nowrap" }}
            >
              Click to select moodboard
            </SuiTypography>
          </SuiBox>
          <SuiBox
            position="absolute"
            top={4}
            right={4}
            display={findIndex != -1 ? "inline" : "none"}
          >
            <CheckCircleIcon color={"success"} fontSize="sm" />
          </SuiBox>
        </Card>

        <SuiBox mt={1} mx={0.5} display="flex" justifyContent="center" alignItems="center">
          <SuiTypography
            variant="h6"
            color="dark"
            textTransform="none"
            sx={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: "1",
              WebkitBoxOrient: "vertical",
            }}
          >
            {photo.name}
          </SuiTypography>
        </SuiBox>
      </div>
    );
  };

  const handleFilterCollections = (str = searchStr) => {
    const copyMoodboards = [...moodboards];
    let filteredList = copyMoodboards; //all projects

    if (str) {
      const strUpper = str.toUpperCase();
      const searchFields = ["name"];
      filteredList = filteredList.filter((x) => {
        let result = false;
        for (let i = 0; i < searchFields.length; i++) {
          if (x[searchFields[i]]) {
            if (typeof x[searchFields[i]] == "string") {
              if (x[searchFields[i]].toUpperCase().includes(strUpper)) {
                result = true;
              }
            } else if (typeof x[searchFields[i]] == "object") {
              const text = JSON.stringify(x[searchFields[i]]);
              if (text.toUpperCase().includes(strUpper)) {
                result = true;
              }
            }
          }
        }
        return result;
      });
    }

    setFilteredMoodboards(filteredList);
  };

  const handleSearchChange = (str) => {
    let formattedStr = "";
    if (str) {
      formattedStr = str.trim();
    }
    setSearchStr(formattedStr);
    handleFilterCollections(formattedStr);
  };

  const handleOnSortChange = (e) => {
    setOrderOpt(e);
    let sortStr = e?.value;
    const newFilteredList = filteredMoodboards.sort((a, b) => compare(a, b, sortStr));
    setFilteredMoodboards(newFilteredList);
  };

  return (
    <Dialog
      open={visible}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="xl"
      fullWidth={true}
    >
      <DialogTitle id="alert-dialog-title">
        Import moodboard{" "}
        <IconButton
          aria-label="close"
          onClick={() => handleClose()}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <SuiBox display="flex" alignItems="center" justifyContent="flex-end" gap={1} mb={1}>
          <SuiBox>
            <Card sx={{ borderRadius: 2, width: 200 }}>
              <SuiSelect
                options={moodboardSortOptions}
                placeholder="Sort"
                isClearable
                onChange={handleOnSortChange}
                value={orderOpt}
              />
            </Card>
          </SuiBox>
          <SuiBox sx={{ maxWidth: 200 }}>
            <SuiInput
              placeholder="Search Keywords"
              type="text"
              onChange={(e) => handleSearchChange(e?.target?.value)}
              icon={{
                direction: "right",
                component: (
                  <SearchIcon
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleSearchChange(searchStr)}
                  />
                ),
              }}
            />
          </SuiBox>
        </SuiBox>

        <SuiBox>
          {filteredMoodboards.length > 0 ? (
            <div>
              <ResponsiveMasonry
                columnsCountBreakPoints={{ 350: 1, 576: 2, 768: 3, 992: 4, 1200: 4, 1400: 4 }}
              >
                <Masonry>{filteredMoodboards.map((x) => renderPhoto(x))}</Masonry>
              </ResponsiveMasonry>
            </div>
          ) : (
            <Empty />
          )}
        </SuiBox>
      </DialogContent>
      <DialogActions>
        <SuiButton variant="gradient" size="medium" onClick={handleClose} color="light">
          Cancel
        </SuiButton>
        <SuiButton
          size="medium"
          variant="gradient"
          color="dark"
          onClick={handleOk ? () => handleOk(selectedItems) : null}
        >
          Import
        </SuiButton>
      </DialogActions>
    </Dialog>
  );
};

export default ImportMoodboardPicture;
